
export const GIFT_CARD_TESTIDS = {
    addGiftCard:'add-gift-card',
    applyGiftCard: 'apply-giftCard',
    submit: 'submit',
    cancel: 'cancel',
    orderTypeDropDownBtn: 'order-type',
    error:'error-field',
    giftCardNumber : 'giftCardNumber',
    giftCardPin : 'giftCardPin',
    giftCard: 'giftCard',
    cancelIcon: 'cancelIcon',

};
